import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
// import { AgreementTemplateComponent } from "./agreement-template.component";
import { CommonModule } from "@angular/common";
import {
  FilterService,  
  GridModule,
  GroupService,
  PageService,
  SortService,
} from "@syncfusion/ej2-angular-grids";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaskedTextBoxModule } from "@syncfusion/ej2-angular-inputs";
import { NgxUiLoaderModule } from "ngx-ui-loader";
import { EmployeeAgreementTemplateModule } from "../employee-agreement-template/employee-agreement-template.module";
// import { AgreementTemplateRoutingModule } from "./agreement-template-routing.module";
import { clienttemplateModule } from "../clienttemplate/clienttemplate.module";
import { NgSelectModule } from "@ng-select/ng-select";
import { HandbookComponent } from "./handbook.component";
import { HandBookRoutingModule } from "./handbook.routing.module";
import { HandBookService } from "./handbook.service";

@NgModule({
  declarations: [HandbookComponent],
  imports: [
    CommonModule,
    GridModule,
    ReactiveFormsModule,
    MaskedTextBoxModule,
    FormsModule,
    NgxUiLoaderModule,
    HandBookRoutingModule,
    EmployeeAgreementTemplateModule,
    clienttemplateModule,
    NgSelectModule
  ],
  schemas:[
    CUSTOM_ELEMENTS_SCHEMA,
  ],
  providers: [PageService, SortService, FilterService, GroupService],
})
export class HandBookModule {}
